import { McIcon } from "./icon.js"

export class McIconBarChart extends McIcon {

  constructor() {
    super()
    const templ = document.createElement("template")
    templ.innerHTML = `
 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column h-4 w-4"
      aria-hidden="true">
      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
      <path d="M18 17V9"></path>
      <path d="M13 17V5"></path>
      <path d="M8 17v-3"></path>
    </svg>
`
    super.addHTML(templ)
  }
}


if (!window.customElements.get("mc-icon-barchart")) window.customElements.define("mc-icon-barchart", McIconBarChart)
